import * as React from "react";
// import { pure } from 'recompose';
// import * as Lodash from 'lodash';
import BoxGrid from "@tunnel-components/@sharded/widgets/box/custom/component";
import SelectSection from "@tunnel-components/@sharded/@widgets/select";
import * as Lodash from "lodash";
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import * as Styled from "@tunnel-components/@sharded/@styled/cart";
import * as i18next from "i18next";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  const {
    isOpen,
    /* toggleModal ,*/ selectSection,
    onClose,
    sections,
    onChange,
    sectionId,
  } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name shortid
   * @infos "https://reactjs.org"
   */
  return (
    <StyledComponent.ModalContainer isVisible={isOpen}>
      <StyledComponent.ModalContainerInsider
        isVisible={isOpen}
        style={{
          overflow: "visible",
          width: "600px",
          backgroundColor: "unset",
        }}
      >
        {isOpen && (
          <BoxGrid
            title={i18next.t("sequence de parametrage")}
            error={
              Lodash.isEqual(sectionId, "eudes") ||
              Lodash.isEqual(sectionId, "")
            }
            onClose={onClose}
            classNames="boderShadow"
            onSubmit={selectSection(Number(sectionId))}
            BtnTextSpan={i18next.t("parametrage")}
          >
            <Styled.CartContainer
              style={{
                padding: "25px 5px",
                boxSizing: "border-box",
                position: "relative",
              }}
            >
              <SelectSection
                error={Lodash.isEqual(sectionId, "eudes")}
                section={true}
                selectedOptions={sections}
                onGetIdentifiantItem={onChange}
                placeholder={i18next.t("rechercher une section")}
              />
            </Styled.CartContainer>
          </BoxGrid>
        )}
      </StyledComponent.ModalContainerInsider>
    </StyledComponent.ModalContainer>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  isOpen?: any;
  selectSection?: any;
  onClose?: any;
  sections?: any;
  onChange?: any;
  sectionId?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/modal/segmentation/component.tsx